import React from 'react';
import './Pagination.css';
import RcPagination from 'rc-pagination';

export type PaginationProps = {
  pageSize: number;
  currentPage: number;
  total: number;
  onChange: (page: number, pageSize: number) => void;
};

type Props = PaginationProps;

const Pagination = React.memo(({ pageSize, currentPage, total, onChange }: Props) => {
  const paginationItemRenderer = React.useCallback(
    (page: number, type: 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next') => {
      // TODO
      if (type === 'prev' || type === 'next' || type === 'jump-next' || type === 'jump-prev') {
        return null;
      }

      return <div>{page}</div>;
    },
    [],
  );

  return (
    <RcPagination
      className="Pagination"
      pageSize={pageSize}
      current={currentPage}
      total={total}
      onChange={onChange}
      itemRender={paginationItemRenderer}
    />
  );
});

export default Pagination;
